import { JSX } from 'react';
import { AiIconName, Icon, IconName, IconProps } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';

export type { AiIconName };

export const AI_ICON_COLOR = colors.orange500;

export type AiIconProps = Omit<IconProps, 'iconName'> & {
  aiColored?: boolean;
};

type AiIconBaseProps = AiIconProps & { iconName: AiIconName };

const AiIconBase = ({
  aiColored,
  color,
  ...iconProps
}: AiIconBaseProps): JSX.Element => (
  <Icon color={aiColored ? AI_ICON_COLOR : color} {...iconProps} />
);

export const AiStarIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_STAR} {...props} />
);

export const AiAddChartIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_ADD_CHART} {...props} />
);

export const AiAddPresentationIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_ADD_PRESENTATION} {...props} />
);

export const AiEditIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_EDIT} {...props} />
);

export const AiFileIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_FILE} {...props} />
);

export const AiLightbulbIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_LIGHTBULB} {...props} />
);

export const AiPersonIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_PERSON} {...props} />
);

export const AiSearchIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_SEARCH} {...props} />
);

export const AiSyncIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_SYNC} {...props} />
);

export const AiTextIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_TEXT} {...props} />
);

export const AiImageIcon = (props: AiIconProps): JSX.Element => (
  <AiIconBase iconName={IconName.AI_IMAGE} {...props} />
);
